import qs from "qs";
import {apiVoissa} from "../../libs/api";


export const fetchMembers = (query = {}, config = {}) => {
    return apiVoissa.get(`/members?${qs.stringify(query)}`, config)
};

export const MEMBERS_KEY = `MEMBERS`;